module.exports = function (hook) {
    var hook = hook || 'data-default-src';
    $('[' + hook + ']').on('error', function(){
        this.src = $(this).attr(hook);
    })
}


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/img_default_src_binding.js
// module id = 68
// module chunks = 10